// @flow
import { createReducer } from 'redux-act';

import { set } from '../actions/source';

const initialState = 'shop';

const setHandler = (state: string, source: string = 'shop'): string => source;

export default (createReducer(
  {
    [set.toString()]: setHandler,
  },
  initialState,
): {
  (): (state: string, payload?: mixed, meta?: mixed) => string,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<string>,
  options: () => mixed,
  ...
});
